var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitLargeMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1117_1521",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V44C0 46.2091 1.79086 48 4 48H14.3043C17.1806 50.7903 20.4884 53.4461 24 56C27.5116 53.4461 30.8194 50.7903 33.6957 48H44C46.2091 48 48 46.2091 48 44V4C48 1.79086 46.2091 0 44 0H4Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V44C0 46.2091 1.79086 48 4 48H14.3043C17.1806 50.7903 20.4884 53.4461 24 56C27.5116 53.4461 30.8194 50.7903 33.6957 48H44C46.2091 48 48 46.2091 48 44V4C48 1.79086 46.2091 0 44 0H4Z",
    fill: "#5144D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3043 48L15.0006 47.2822L14.7097 47H14.3043V48ZM24 56L23.4118 56.8087L24 57.2365L24.5882 56.8087L24 56ZM33.6957 48V47H33.2903L32.9994 47.2822L33.6957 48ZM1 4C1 2.34315 2.34315 1 4 1V-1C1.23858 -1 -1 1.23857 -1 4H1ZM1 44V4H-1V44H1ZM4 47C2.34315 47 1 45.6569 1 44H-1C-1 46.7614 1.23857 49 4 49V47ZM14.3043 47H4V49H14.3043V47ZM13.608 48.7178C16.5295 51.5519 19.8774 54.2383 23.4118 56.8087L24.5882 55.1913C21.0993 52.6539 17.8317 50.0287 15.0006 47.2822L13.608 48.7178ZM24.5882 56.8087C28.1226 54.2383 31.4705 51.5519 34.392 48.7178L32.9994 47.2822C30.1683 50.0287 26.9007 52.6539 23.4118 55.1913L24.5882 56.8087ZM44 47H33.6957V49H44V47ZM47 44C47 45.6569 45.6569 47 44 47V49C46.7614 49 49 46.7614 49 44H47ZM47 4V44H49V4H47ZM44 1C45.6569 1 47 2.34315 47 4H49C49 1.23858 46.7614 -1 44 -1V1ZM4 1H44V-1H4V1Z",
    fill: "black",
    fillOpacity: 0.4,
    mask: "url(#path-1-inside-1_1117_1521)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitLargeMarker);
export default __webpack_public_path__ + "static/media/unit-large-marker.075f6fa865a6ef7f3475bfe0018e9fca.svg";
export { ForwardRef as ReactComponent };